import React from 'react'
import { Segment } from 'semantic-ui-react'
import { translate } from 'loankeeper-common/helpers'
import LKGrid from '../../../shared/LKGrid'
import LKModal from '../../../shared/LKModal'
import withConstantPermissions from '../../../shared/containers/withConstantPermissions'
import AccountPermissionAdd, { AccountPermissionAddTrigger } from './AccountPermissionsAdd'
import { constants as DCConstants } from '../../../DetailsContainer'
import { LKGridConfig } from './grid.config'
import container from './container'
import { AccountDetailsAccessPermissionsProps } from '../../AccountDetails.types'

// @ts-ignore
@withConstantPermissions(['ADD_RL as CanAdd'])
@container
class AccessPermissions extends React.PureComponent<AccountDetailsAccessPermissionsProps> {
  static defaultProps = {
    data: [],
  }

  render() {
    const { data, loading, ID, hash, CanAdd } = this.props

    return (
      <div className="u-flex u-directionColumn u-fluid u-marginRight-20">
        {/** @ts-ignore */}
        <LKModal.Confirmation
          name="AccountDeleteAccessPermission"
          onConfirm={this.props.deletePermission}
          loading={loading}
        />

        <Segment className="u-marginBottom-5 u-noPadding u-fluid" attached="bottom">
          <LKGrid
            instanceName={`${DCConstants.DetailsGridPrefixes.account}-${ID}-AccessPermissions`}
            rowData={data}
            {...LKGridConfig}
          />
        </Segment>

        <div>
          {CanAdd && <AccountPermissionAddTrigger>{translate('frm_sec_RL-cmd_add')}</AccountPermissionAddTrigger>}
          {/* @ts-ignore */}
          <AccountPermissionAdd addedPermissions={data} ID={ID} hash={hash} />
        </div>
      </div>
    )
  }
}

export default AccessPermissions
